import { IUser, EUserRole } from '../../types/user'
import { type_AUTH_FETCH_USER } from '../types'

export const initialState: IUser = {
    name: '',
    id: '',
    email: '',
    description: '',
    metaName: '',
    avatar: '',
    createdAt: '',
    isActivated: false,
    role: EUserRole.Guest,
    socialInstagram: '',
    socialOnlyfans: '',
    socialTwitch: '',
    socialTwitter: '',
    metamaskAddress: '',
    totalSalesProfit: '0',
    totalSalesCount: 0,
    background: null,
}

type UserFetch = {
    type: typeof type_AUTH_FETCH_USER
    payload: IUser
}

export const authReducer = (state = initialState, action: UserFetch) => {
    switch (action.type) {
        case type_AUTH_FETCH_USER:
            return (state = action.payload)

        default:
            return state
    }
}
